import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    privacyContainer: {
      justifyContent: "flex-start",
      [theme.breakpoints.up("md")]: {
        justifyContent: "center",
      },
    },
    termsContainer: {
      justifyContent: "flex-end",
      [theme.breakpoints.up("md")]: {
        justifyContent: "center",
      },
    },
    bottomButtons: {
      padding: 0,
      color: theme.palette.primary.contrastText,
      fontSize: 13,
      textTransform: "initial",
    },
    pepsicoCopyright: {
      position: "absolute",
      left: 10,
      bottom: 15,

      "& p": {
        color: theme.palette.primary.contrastText,
        fontSize: 13,
      },
    },
  })
);

export default useStyles;
